import { ApiSmpArtGallery, FailureApi } from "@smp/api";
import produce from "immer";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useQueryPolotnoUserTemplates } from "@/queries";

type Params = Parameters<typeof ApiSmpArtGallery.Polotno.patchUserTemplate>[0];
type Response = Awaited<
  ReturnType<typeof ApiSmpArtGallery.Polotno.patchUserTemplate>
>;

const KEY = "USE_MUTATION_POLOTONO_USER_TEMPLATE_PATCH";

export const useMutationPolotonoUserTemplatePatch = (
  options?: UseMutationOptions<Response, FailureApi, Params>,
) => {
  const queryClient = useQueryClient();

  return useMutation(ApiSmpArtGallery.Polotno.patchUserTemplate, {
    ...options,
    mutationKey: KEY,
    onSuccess: (...args) => {
      const updatedTemplate = args[0];

      queryClient.setQueriesData<
        ReturnType<typeof useQueryPolotnoUserTemplates>["data"]
      >(useQueryPolotnoUserTemplates.KEY, (data) =>
        produce(data, (draft) => {
          if (draft?.pages) {
            draft?.pages.forEach((page) => {
              page.results = page.results.map((result) =>
                result.id === updatedTemplate.id ? updatedTemplate : result,
              );
            });
          }
        }),
      );

      options?.onSuccess?.(...args);
    },
  });
};

useMutationPolotonoUserTemplatePatch.KEY = KEY;
